import { atom } from "recoil";
import { parametersDefault, parametersSimpleDefault } from "../consts/consts";
import { UserType } from "../types/types";

export const selectedParametersAtom = atom({
    key: "selectedParametersAtom",
    default: parametersDefault
});

export const selectedCustomerToManagerMapAtom = atom({
    key: "selectedCustomerToManagerMap",
    default: parametersSimpleDefault
});

export const userAtom = atom<UserType>({
    key: 'userAtom',
    default: {
        id: -1,
        name: "",
        email: "",
        customer: {} as any,
        accessProfile: { id: -1, name: "" },
        permissions: [],
        configs: {
            isActivated: true,
            isBlocked: false,
            isManager: true,
            isDriver: false,
            customerSettings: {} as any,
            useGtf: false
        }
    }
});